import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { AiOutlineSearch } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import { styled as tooltipStyled } from '@mui/material/styles';

import Spinner from 'web/components/Spinner';
import Timmer from "web/components/Timmer";
import DatePicker from "web/components/DatePicker";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import information from "web/assets/images/notification-blue.png";
import { companyList, postVisibilityListV2 } from '../../../../../redux/actions/admin';
import { SearchWrapper, SelectWrapper, SelectWrapperPostVisibilty } from '../DashBoard/dashBoardStyled';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled';

import UpArrowIcon from "web/assets/svg/UpArrowBlue";
import { hideAppLoader } from 'redux/actions/app';
import DownArrowBlueIcon from "web/assets/svg/DownArrowBlueIcon";
import EditIcon from "web/assets/svg/EditUnderlineIcon";
import MultiSelect from "./MultiSelect";
import CommentModal from "./CommentModal";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import Pagination from '@material-ui/lab/Pagination';

import Typography from '@material-ui/core/Typography';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import styles from './posts.module.scss';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import NeedTabPanel from './PostModuleTabs/NeedTabPanel';
import InventoryTabPanel from './PostModuleTabs/InventoryTabPanel';
import {
    postNeedHeaderArr,
    postInventoryHeaderArr,
    postStatusList
} from "./Constants";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Users({downloadPostVisibilityReportCSV, isDownloadingPostVisibilityCSV}) {
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const dispatch = useDispatch();
    let history = useHistory()

    const [multiSelectVal, setMultiSelectVal] = useState();
    const [commentModal, setCommentModal] = useState(false)
    const [editFlag, setEditFlag] = useState(false)
    const [csvFlag, setCSVFlag] = useState(false)
    const [exportModal, setExportModal] = useState(false)

    const [bidOfferStatusList, setBidOfferStatusList] = useState(['ALL', 'PENDING', 'ACCEPTED', 'DECLINED'])

    const [multiSelectCompanyVal, setMultiSelectCompanyVal] = useState();

    const [filterType, setfilterType] = useState('ALL')

    const [bidStatusType, setBidStatusType] = useState('ALL')
    const requestFilterList = ['Ascending', 'Descending']
    const [requestFilter, setRequestFilter] = useState('Descending')
    const [loader, setLoader] = useState(false)
    const [timmerLoader, setTimmerLoader] = useState(false)
    const [accordionOpenIndex, setAccordionOpenIndex] = useState()
    const [accordionInsideOpenIndex, setAccordionInsideOpenIndex] = useState()
    const [needAccordionInsideOpenIndex, setNeedAccordionInsideOpenIndex] = useState()
    const [activePage, setActivePage] = useState('userList')
    const [value, setValue] = useState(0);
    const [modal, setModal] = useState(false);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [modalMessage, setModalMessaage] = useState('')

    const [editComment, setEditComment] = useState([])

    const [postNeedDataList, setPostNeedDataList] = useState([])
    const [postInventoryDataList, setPostInventoryDataList] = useState([])
    const [needCsvData, setNeedCsvData] = useState([])
    const [invCsvData, setInvCsvData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [needPage, setNeedPage] = useState(1);
    const [needPageCount, setNeedPageCount] = useState(0);

    let toDatePostModule = new Date();
    let fromDatePostModule = new Date();
    toDatePostModule.setMonth(toDatePostModule.getMonth() + 1)

    const [startDateValue, setStartDateValue] = useState(moment(fromDatePostModule).format("MM/DD/YYYY"))
    const [endDateValue, setEndDateValue] = useState(moment(toDatePostModule).format("MM/DD/YYYY"))

    const [userFilterState, setUserFilterState] = useState({
        fromDate: moment(fromDatePostModule).format("YYYY-MM-DD"),
        toDate: moment(toDatePostModule).format("YYYY-MM-DD"),
        posts: '',
        company: "ALL",
        status: "ALL",
        bidStatus: "ACTIVE"
    });

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        companyListApi()
        fetchPostNeedAPI(0);
    }, []);

    useEffect(() => {
        // Check if the value is equal to 1, and add 'TIME OUT' to the array if true
        if (value === 1) {
          setBidOfferStatusList(['ALL', 'PENDING', 'ACCEPTED', 'DECLINED', 'TIME OUT']);
        } else {
          // Reset the array without 'TIME OUT' if the value is not 1
          setBidOfferStatusList(['ALL', 'PENDING', 'ACCEPTED', 'DECLINED']);
        }
      }, [value]);

    //change tab index
    const handleChangeTab = (event, newValue) => {
        setMultiSelectCompanyVal()
        setCompanyListState()
        setPostNeedDataList([])
        setNeedPageCount()
        setNeedPage(1)
        setCSVFlag(false)
        setExportModal(false)
        setNeedPageCount(0)
        setPostInventoryDataList([])

        setValue(newValue);
        setAccordionOpenIndex()
        setAccordionInsideOpenIndex()
        setNeedAccordionInsideOpenIndex()
        setfilterType("ALL")
        setBidStatusType("ALL")
        setMultiSelectVal()
        setAccordionFunction()
        companyListApi()
        setTableSearch('')
        if (newValue === 0) {
            let toDate = new Date();
            let fromDate = new Date();
            toDate.setMonth(toDate.getMonth() + 1)
            setUserFilterState(prevState => ({
                ...prevState,
                ["fromDate"]: moment(fromDate).format("YYYY-MM-DD"),
                ["toDate"]: moment(toDate).format("YYYY-MM-DD")
            }))
            setStartDateValue(moment(fromDate).format("MM/DD/YYYY"))
            setEndDateValue(moment(toDate).format("MM/DD/YYYY"))
            fetchPostNeedAPI(0, '', true, moment(fromDate).format("YYYY-MM-DD"), moment(toDate).format("YYYY-MM-DD"))
        } else {
            let toDate = new Date();
            let fromDate = new Date();
            toDate.setMonth(toDate.getMonth() + 1)
            setUserFilterState(prevState => ({
                ...prevState,
                ["fromDate"]: moment(fromDate).format("YYYY-MM-DD"),
                ["toDate"]: moment(toDate).format("YYYY-MM-DD")
            }))
            setStartDateValue(moment(fromDate).format("MM/DD/YYYY"))
            setEndDateValue(moment(toDate).format("MM/DD/YYYY"))
            fetchPostInventoryAPI(0, '', true, moment(fromDate).format("YYYY-MM-DD"), moment(toDate).format("YYYY-MM-DD"))
        }
    };
    
    const [companyListState, setCompanyListState] = useState()
    const companyListApi = async () => {
        let response = await dispatch(companyList());
        if (response && response?.data?.status === 'SUCCESS') {
            if (response?.data?.payload) {
                let arr = []
                for (let i = 0; i < response.data?.payload.length; i++) {
                    let obj = {
                        label: response.data?.payload[i].companyName,
                        value: response.data?.payload[i].locationId,
                    }
                    arr.push(obj)

                    if (response.data?.payload.length - 1 === i) {
                        setCompanyListState(arr)
                    }
                }
            }
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response.message)
                setModal(!modal)
            }
        }
    };
    const fetchPostNeedAPI = async (selectPage, search, flag, getFromDate, getToDate) => {
        let companyArr = []
        if (!flag && multiSelectCompanyVal) {
            for (let i = 0; i < multiSelectCompanyVal.length; i++) {
                companyArr.push(multiSelectCompanyVal[i].value)
            }
        }

        let statusArr = []
        if (!flag && multiSelectVal) {
            for (let i = 0; i < multiSelectVal.length; i++) {
                statusArr.push(multiSelectVal[i].value)
            }
        }
        if((!getFromDate || !getToDate) && (!userFilterState.toDate || !userFilterState.fromDate)){
            setModalMessaage("Please enter the correct Date Range.");
            setModal(!modal)
            return
        }

        let data = {
            size: 10,
            number: selectPage,
            sort: requestFilter === "Ascending" ? "ASC" : "DESC",
            postType: "NEED",
            status: flag ? ["ALL"] : [filterType],
            bidOfferStatus: flag ? ["ALL"] : [bidStatusType],
            companyId: companyArr.length !== 0 ? companyArr : [userFilterState.company],
            searchBy: search || tableSearch || "",
            startDate: getFromDate ? getFromDate : userFilterState.fromDate,
            endDate: getToDate ? getToDate : userFilterState.toDate,
            requestDate: true //to sort data, false: sort by post name
        }

        let response = await dispatch(postVisibilityListV2(data))

        if (response && response?.success) {
            dispatch(hideAppLoader());
            if (response?.data?.needList && response?.data?.needList.length !== 0) {
                setPostNeedDataList(response?.data?.needList)
                setNeedPageCount(response?.data?.totalPages)
            } else {
                setPostNeedDataList([])
                setNeedPageCount(0)
            }
        } else {
            dispatch(hideAppLoader());
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
                setModal(!modal)
            }
        }
    };

    const fetchPostInventoryAPI = async (selectPage, search, flag, getFromDate, getToDate) => {
        let companyArr = []
        if (!flag && multiSelectCompanyVal) {
            for (let i = 0; i < multiSelectCompanyVal.length; i++) {
                companyArr.push(multiSelectCompanyVal[i].value)
            }
        }

        let statusArr = []
        if (!flag && multiSelectVal) {
            for (let i = 0; i < multiSelectVal.length; i++) {
                statusArr.push(multiSelectVal[i].value)
            }
        }

        if((!getFromDate || !getToDate) && (!userFilterState.toDate || !userFilterState.fromDate)){
            setModalMessaage("Please enter the correct Date Range.");
            setModal(!modal)
            return
        }

        let data = {
            size: 10,
            number: selectPage,
            sort: requestFilter === "Ascending" ? "ASC" : "DESC",
            postType: "INVENTORY",
            status: flag ? ["ALL"] : [filterType],
            bidOfferStatus: flag ? ["ALL"] : [bidStatusType],
            companyId: companyArr.length !== 0 ? companyArr : [userFilterState.company],
            searchBy: search || tableSearch || "",
            startDate: getFromDate ? getFromDate : userFilterState.fromDate,
            endDate: getToDate ? getToDate : userFilterState.toDate,
            requestDate: true //to sort data, false: sort by post name
        }

        let response = await dispatch(postVisibilityListV2(data))

        if (response && response?.success) {
            dispatch(hideAppLoader());
            if (response?.data?.inventoryList && response?.data?.inventoryList.length !== 0) {
                setPostInventoryDataList(response?.data?.inventoryList)
                setNeedPageCount(response?.data?.totalPages)
            } else {
                setPostInventoryDataList([])
                setNeedPageCount(0)
            }
        } else {
            dispatch(hideAppLoader());
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
                setModal(!modal)
            }
        }
    };

    //handle page change in needs
    const handleNeedPageChange = (event, value) => {
        setNeedPage(value);
        setPostNeedDataList([])
        setPostInventoryDataList([])
        fetchPostNeedAPI(value - 1, tableSearch)
    };

    //handle page change in inventories
    const handleInventoryPageChange = (event, value) => {
        setNeedPage(value);
        setPostNeedDataList([])
        setPostInventoryDataList([])
        fetchPostInventoryAPI(value - 1, tableSearch)
    };

    const handleToggle = () => {
        setModal(!modal);
    }

    const handleSearchChange = (e, value) => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        setPostNeedDataList([])
        setPostInventoryDataList([])
        if (value === 0) {
            // post needs
            setNeedPage(1)
            fetchPostNeedAPI(0, search);
        } else {
            setNeedPage(1)
            fetchPostInventoryAPI(0, search);
        }
    }

    const setAccordionFunction = index => {
        setAccordionInsideOpenIndex()
        setNeedAccordionInsideOpenIndex()
        setAccordionOpenIndex(index)
    }

    const setNeedAccordionInsideFunction = index => {
        setNeedAccordionInsideOpenIndex(index)
    }
    const setAccordionInsideFunction = index => {
        setAccordionInsideOpenIndex(index)
    }

    const orderType = (items, bidQty) => {
        let totalQuantity = (bidQty && bidQty !== 0 && bidQty !== null) ? bidQty : (items?.postQuantity ? items?.postQuantity : items?.quantity ? items?.quantity : '')
        let material = items?.palletDetails?.material
        material = material?.toString()
        material = material?.toLowerCase();
        material = material?.replace(/\b\w/g, c => c.toUpperCase())
        let condition
        if (items?.palletDetails?.condition?.length !== 1) {
            condition = items?.palletDetails?.condition?.join(", ")
            condition = condition?.toString()
            condition = condition?.toLowerCase();
            condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
        } else {
            if (items?.palletDetails?.condition.length !== 0)
                condition = items?.palletDetails?.condition
            condition = condition?.toString()
            condition = condition?.toLowerCase();
            condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
        }

        let palletType;
        let moisture = "";
        let size = "";
        let grade = "";
        let LWH
        if (items?.palletDetails?.material !== "WOOD") {
            const length = items?.palletDetails?.length
            const width = items?.palletDetails?.width
            const height = items?.palletDetails?.height
            LWH = length + "x" + width + "x" + height

            if (condition) {
                condition = condition?.toString()
                condition = condition?.toLowerCase();
                condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
                if (totalQuantity) {
                    return totalQuantity + " - " + material + "-" + LWH + "-" + condition
                } else {
                    return material + "-" + LWH + "-" + condition
                }

            } else {
                if (totalQuantity) {
                    return totalQuantity + " -" + material + " - " + LWH
                } else {
                    return material + " - " + LWH
                }

            }

        } else {
            palletType = items?.palletDetails?.palletType
            if (items?.palletDetails?.moisture)
                moisture = " - " + items?.palletDetails?.moisture

            if (items?.palletDetails?.size)
                size = items?.palletDetails?.size

            if (items?.palletDetails?.grade)
                grade = " - " + items?.palletDetails?.grade

            palletType = palletType?.toLowerCase();
            palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
            condition = condition?.toString()
            condition = condition?.toLowerCase();
            condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
            if (totalQuantity) {
                return totalQuantity + " - " + size + "" + grade + "" + moisture + " - " + palletType + "-" + condition
            } else {
                return size + "" + grade + "" + moisture + " - " + palletType + "-" + condition
            }
        }
    }

    const buttonStyle = { background: '#61b01f', minHeight: "46px", background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

    const handleStateChange = (event) => {
        if (event.target.value === "ACTIVE") {
            if(value === 1) setBidOfferStatusList(['ALL', 'PENDING', 'DECLINED', 'TIME OUT'])
            else setBidOfferStatusList(['ALL', 'PENDING', 'DECLINED'])
            setBidStatusType("ALL")
        }
        if (event.target.value === "EXPIRED") {
            setBidOfferStatusList([])
            setBidStatusType('ALL')
        }
        if (event.target.value === "NO ACTION") {
            if(value === 1) setBidOfferStatusList(['PENDING', 'DECLINED', 'TIME OUT'])
            else setBidOfferStatusList(['PENDING', 'DECLINED'])
            setBidStatusType("PENDING")
        }
        if (event.target.value === "ORDER CREATED") {
            setBidOfferStatusList(['ACCEPTED'])
            setBidStatusType("ACCEPTED")
        }
        if (event.target.value === "ALL") {
            if(value === 1) setBidOfferStatusList(['ALL', 'PENDING', 'ACCEPTED', 'DECLINED', 'TIME OUT'])
            else setBidOfferStatusList(['ALL', 'PENDING', 'ACCEPTED', 'DECLINED'])
            setBidStatusType("ALL")
        }
        setfilterType(event.target.value)
    }
    const handleBidStateChange = (event) => {
        setBidStatusType(event.target.value)
    }

    const handleRequestedDateChange = (event) => {
        setRequestFilter(event.target.value)
    }

    const HtmlTooltip = tooltipStyled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#efefef !important',
            color: 'rgba(0, 0, 0, 0.87) ',
            border: '1px solid #dadde9',
        },
    }));
    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('POST_VISIBILITY'))) ?
                <Container>
                    {activePage === 'userList' &&
                        <TableWrapper>
                            {(loaderVisible || loader) && <Spinner />}
                            <div class="column">
                                <Heading>
                                    <h3>POSTS</h3>
                                    <div className='d-flex flex-wrap flex-sm-nowrap'>
                                        <SearchWrapper>
                                            <input type="text" placeholder='Search' value={tableSearch}
                                                onChange={(e) => {
                                                    handleSearchChange(e, value)
                                                }}
                                            />
                                            <AiOutlineSearch />
                                        </SearchWrapper>
                                        <button
                                            disabled={isDownloadingPostVisibilityCSV}
                                            onClick={() => {
                                                if(!userFilterState.toDate || !userFilterState.fromDate){
                                                    setModalMessaage("Please enter the correct Date Range.");
                                                    setModal(!modal)
                                                    return
                                                }
                                                const postType = value === 0 ? "NEED" : "INVENTORY"
                                                downloadPostVisibilityReportCSV(multiSelectCompanyVal, postType, requestFilter,bidStatusType, tableSearch, filterType, userFilterState, dispatch)
                                            }}
                                            style={{ background: isDownloadingPostVisibilityCSV ? '#b2afac' : 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', minHeight: "46px", color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }}>
                                            {isDownloadingPostVisibilityCSV ? "Exporting..." : "Export"}
                                        </button>

                                    </div>
                                </Heading>
                                <InnerHeader className="posts-inner-header">
                                    <SelectWrapperPostVisibilty>
                                        <label>{value === 0 ? "Request Delivery Date From" : "Post Created Date From"}:</label>
                                        <DatePicker
                                            name="fromDatePostModule"
                                            placeholderText=""
                                            maxDOBirth={userFilterState.toDate}
                                            value={userFilterState.fromDate}
                                            inputValue={startDateValue}
                                            callBackFun={(date, value) => {
                                                setStartDateValue(value)
                                                if (moment(date, moment.ISO_8601, true).isValid()) {
                                                    setUserFilterState((prevState) => ({
                                                        ...prevState,
                                                        ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                                                    }));
                                                } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                    setUserFilterState((prevState) => ({
                                                        ...prevState,
                                                        ["fromDate"]: null,
                                                    }));
                                                }
                                            }}
                                        />

                                    </SelectWrapperPostVisibilty>
                                    <SelectWrapperPostVisibilty>
                                        <label>{value === 0 ? "Request Delivery Date To" : "Post Created Date To"}:</label>
                                        <DatePicker
                                            name="toDatePostModule"
                                            placeholderText=""
                                            minDOBirth={userFilterState.fromDate}
                                            value={userFilterState.toDate}
                                            inputValue={endDateValue}
                                            callBackFun={(date, value) => {
                                                setEndDateValue(value)
                                                if (moment(date, moment.ISO_8601, true).isValid()) {
                                                    setUserFilterState((prevState) => ({
                                                        ...prevState,
                                                        ["toDate"]: moment(date).format("YYYY-MM-DD"),
                                                    }));
                                                } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                    setUserFilterState((prevState) => ({
                                                        ...prevState,
                                                        ["toDate"]: null,
                                                    }));
                                                }
                                            }}
                                        />
                                    </SelectWrapperPostVisibilty>
                                    <SelectWrapperPostVisibilty>
                                        <label>Company:</label>
                                        <MultiSelect
                                            data={companyListState}
                                            name="company"
                                            placeholder='Select'
                                            multiSelectVal={multiSelectCompanyVal}
                                            defaultValueArr={multiSelectCompanyVal}
                                            allSelect={true}
                                            multi={true}
                                            // locationName={locationName}
                                            setMultiSelectVal={(multiSelectVal) => {
                                                if (multiSelectVal) {
                                                    setMultiSelectCompanyVal(multiSelectVal)
                                                } else {
                                                    setMultiSelectCompanyVal()
                                                }
                                            }}
                                        />
                                    </SelectWrapperPostVisibilty>

                                    <SelectWrapperPostVisibilty>
                                        <label>Post Status:</label>
                                        <select
                                            //  style={selectStyle}
                                            id="status"
                                            value={filterType}
                                            onChange={handleStateChange}
                                        >
                                            {postStatusList.map((data) => {
                                                return <option value={data}>{data?.charAt(0)}{data?.slice(1)?.toLowerCase()}</option>;
                                            })}
                                        </select>
                                    </SelectWrapperPostVisibilty>
                                    {bidOfferStatusList.length !== 0 && <SelectWrapperPostVisibilty>
                                        <label>{value === 0 ? 'Bid Status' : 'Offer Status'}:</label>
                                        <select
                                            id="status"
                                            value={bidStatusType}
                                            onChange={handleBidStateChange}
                                        >
                                            {bidOfferStatusList.map((data) => {
                                                return <option value={data}>{data?.charAt(0)}{data?.slice(1)?.toLowerCase()}</option>;
                                            })}

                                        </select>
                                    </SelectWrapperPostVisibilty>}
                                    <SelectWrapperPostVisibilty>
                                        <label>{value === 0 ? "Sort by Request delivery date" : "Sort by Requested date"}:</label>
                                        <select
                                            id="requestedDate"
                                            value={requestFilter}
                                            onChange={handleRequestedDateChange}
                                        >
                                            {requestFilterList.map((data) => {
                                                return <option value={data}>{data?.charAt(0)}{data?.slice(1)?.toLowerCase()}</option>;
                                            })}
                                        </select>
                                    </SelectWrapperPostVisibilty>
                                    <SelectWrapper>
                                        <label style={{ "margin-top": "26px" }}></label>
                                        <button
                                            style={buttonStyle}
                                            onClick={() => {
                                                setPostNeedDataList([])
                                                setPostInventoryDataList([])
                                                if (value === 0) {
                                                    setNeedPage(1)
                                                    fetchPostNeedAPI(0, tableSearch);
                                                } else {
                                                    setNeedPage(1)
                                                    fetchPostInventoryAPI(0, tableSearch);
                                                }
                                            }}
                                        >
                                            Submit
                                        </button>
                                    </SelectWrapper>
                                </InnerHeader>
                            </div>

                            <AppBar position="static">
                                <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                                    <Tab label="Posted Pallet Need" {...a11yProps(0)} />
                                    <Tab label="Posted Pallet Inventory" {...a11yProps(1)} />
                                </Tabs>
                            </AppBar>

                            <NeedTabPanel
                                TabPanel={TabPanel}
                                value={value}
                                postNeedHeaderArr={postNeedHeaderArr}
                                HtmlTooltip={HtmlTooltip}
                                postNeedDataList={postNeedDataList}
                                styles={styles}
                                EditIcon={EditIcon}
                                setCommentModal={setCommentModal}
                                setEditComment={setEditComment}
                                UpArrowIcon={UpArrowIcon}
                                setAccordionFunction={setAccordionFunction}
                                DownArrowBlueIcon={DownArrowBlueIcon}
                                setTimmerLoader={setTimmerLoader}
                                accordionOpenIndex={accordionOpenIndex}
                                TdCollapseSectionInner={TdCollapseSectionInner}
                                setNeedAccordionInsideFunction={setNeedAccordionInsideFunction}
                                needAccordionInsideOpenIndex={needAccordionInsideOpenIndex}
                                orderType={orderType}
                                needPageCount={needPageCount}
                                Pagination={Pagination}
                                needPage={needPage}
                                handleNeedPageChange={handleNeedPageChange}
                                information={information}
                                stateConvert={stateConvert}
                                loader={loader}
                                Timmer={Timmer}
                                timmerLoader={timmerLoader}
                                loaderVisible={loaderVisible}
                            />

                            <InventoryTabPanel
                                TabPanel={TabPanel}
                                value={value}
                                postInventoryHeaderArr={postInventoryHeaderArr}
                                HtmlTooltip={HtmlTooltip}
                                information={information}
                                postInventoryDataList={postInventoryDataList}
                                styles={styles}
                                stateConvert={stateConvert}
                                loader={loader}
                                Timmer={Timmer}
                                setCommentModal={setCommentModal}
                                setEditComment={setEditComment}
                                EditIcon={EditIcon}
                                accordionOpenIndex={accordionOpenIndex}
                                UpArrowIcon={UpArrowIcon}
                                setAccordionFunction={setAccordionFunction}
                                DownArrowBlueIcon={DownArrowBlueIcon}
                                TdCollapseSectionInner={TdCollapseSectionInner}
                                accordionInsideOpenIndex={accordionInsideOpenIndex}
                                setAccordionInsideFunction={setAccordionInsideFunction}
                                orderType={orderType}
                                loaderVisible={loaderVisible}
                                needPageCount={needPageCount}
                                Pagination={Pagination}
                                needPage={needPage}
                                handleInventoryPageChange={handleInventoryPageChange}
                            />

                        </TableWrapper>
                    }

                    <Modal isOpen={modal}>
                        <ModalHeader toggle={handleToggle}><h6>Status</h6></ModalHeader>
                        <ModalBody>
                            {modalMessage}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>

                    {commentModal && <Modal style={{ maxWidth: "972px" }} size="xl" isOpen={setCommentModal} centered={true}>
                        <CommentModalWrapper>
                            <ModalBody>
                                <CommentModal editResponse={editComment} tabValue={value} editFlag={editFlag} toggle={() => {
                                    setCommentModal(false)
                                    if (value === 0) {
                                        fetchPostNeedAPI(needPage - 1)
                                    } else {
                                        fetchPostInventoryAPI(needPage - 1)
                                    }

                                }} />
                            </ModalBody>
                        </CommentModalWrapper>
                    </Modal>}
                </Container >

                :
                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default Users;

const Container = styled.div`
`

const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 0 20px;
    align-items: flex-end;
    border-bottom: solid 1px #97979729;
    padding: 0 20px;
    gap: 10px;
    padding-bottom: 15px;
    flex-wrap: wrap;
    &.posts-inner-header {
        align-items: flex-start;
        > button {
            align-self: center;
        }
    }
`

const TdCollapseSectionInner = styled.div`
    display: inline-flex;
    align-items: center;
`

const CommentModalWrapper = styled.div`
    .modal-body{
      padding: 0px !important;
    }
    .modal-content{
      border-radius: 0px !important;
    }
    .modal-header-style{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0px;
      h6{
        margin: 12px 12px 12px 25px;
        font-weight: bold;
      }
      img{
        margin: 12px 25px 12px 12px;
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
    .modal-content-style{
      display: flex;
      padding: 15px 25px 15px 25px;
      justify-content: space-between;
      input{
        min-width: 404px;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: #9c9c9c !important;
        font-size: 14px !important;
      }
      .invite-email-style{
        padding: 5px 5px 5px 15px;
        border: 1px solid #DADADF;
        border-radius: 4px;
        width: 75%;
        font-size: 14px;
      }
      .invite-button-disabled{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: #F2F2F2;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        font-size: 14px;
      }
      .invite-button{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: linear-gradient(180deg, #55C416 0%, #367910 100%);
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
      }
      .app-input-text{
        margin-bottom: 15px !important;
      }
    }
    .specfiles-wrapper{
      .check-disabled{
        .radio-checkmark{
          background: grey;
          border: none;
        }
      }
    }
`;